import React from "react";
import { Divider, Typography } from "@mui/material";

// The "AND" separator rendered between AND-joined base conditions.
export const ConditionAndDivider: React.FC = () => (
  <Divider>
    <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary" }}>
      AND
    </Typography>
  </Divider>
);
